import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import { Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getReportSaleIntendantBranch } from "../../redux/handlers/report/getReportSaleIntendantBranch.handler";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getShop } from "../../redux/handlers/manage/getShop.handler";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getInfoAdminSystem } from "utils/HelperFunction";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { BranchOrderNoteDocument } from "./BranchOrderNotePdf";
import { utils, writeFileXLSX } from "xlsx-js-style";
import { buildSaleIntendantBranchWorksheet, getBranchGradeText, getPaymentText, getShippingPayTypeText, getShopTypeText } from "../../utils/saleIntendantBranchExcel";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import StoreIcon from "@mui/icons-material/Store";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
var SHOP_TYPE_ORDER = {
    3: 0,
    2: 1,
    1: 2
};
var SHOP_TYPE_ROW_STYLES = [
    {
        when: function(row) {
            return Number(row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) === 3;
        },
        style: {
            backgroundColor: "#fdeaea"
        }
    },
    {
        when: function(row) {
            return Number(row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) === 2;
        },
        style: {
            backgroundColor: "#fff1e5"
        }
    },
    {
        when: function(row) {
            return Number(row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) === 1;
        },
        style: {
            backgroundColor: "#eaf7ea"
        }
    }
];
export function ReportSaleIntendantBranch() {
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var isSaleRole = Number(adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) === 3;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), optionShop = _useState[0], setOptionShop = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), shopId = _useState1[0], setShopId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), shopTypeId = _useState2[0], setShopTypeId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), branchGrade = _useState3[0], setBranchGrade = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), payStatus = _useState4[0], setPayStatus = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), shippingPayType = _useState5[0], setShippingPayType = _useState5[1];
    var _useState6 = _sliced_to_array(useState(isSaleRole ? Number(adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId) : ""), 2), saleId = _useState6[0], setSaleId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), filterText = _useState7[0], setFilterText = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionSale = _useState8[0], setOptionSale = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), rowData = _useState9[0], setRowData = _useState9[1];
    var _useState10 = _sliced_to_array(useState({}), 2), summary = _useState10[0], setSummary = _useState10[1];
    var optionShopType = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "RT"
        },
        {
            value: 2,
            label: "WT"
        },
        {
            value: 3,
            label: "MT"
        }
    ];
    var optionBranchGrade = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "Level 1"
        },
        {
            value: 2,
            label: "Level 2"
        },
        {
            value: 3,
            label: "Level 3"
        },
        {
            value: 4,
            label: "Level 4"
        }
    ];
    var optionPayStatus = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "เครดิต"
        }
    ];
    var optionShippingPayType = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "ต้นทาง"
        },
        {
            value: 2,
            label: "ปลายทาง"
        }
    ];
    var getReportSaleIntendantBranchReducer = useAppSelector(function(state) {
        return state.getReportSaleIntendantBranchReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    useEffect(function() {
        dispatch(getShop({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        dispatch(getReportSaleIntendantBranch({
            saleid: parseInt(saleId),
            shopid: parseInt(shopId),
            shoptype: parseInt(shopTypeId),
            branchgrade: parseInt(branchGrade),
            paystatus: parseInt(payStatus),
            shippingpaytype: parseInt(shippingPayType)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        saleId,
        shopId,
        shopTypeId,
        branchGrade,
        payStatus,
        shippingPayType
    ]);
    useEffect(function() {
        setIsLoading(getReportSaleIntendantBranchReducer.isFetching || getShopReducer.isFetching || allSetUserReducer.isFetching);
        if (getReportSaleIntendantBranchReducer.data) {
            var _getReportSaleIntendantBranchReducer_data_data, _getReportSaleIntendantBranchReducer_data, _getReportSaleIntendantBranchReducer_data_data1, _getReportSaleIntendantBranchReducer_data1;
            setRowData((getReportSaleIntendantBranchReducer === null || getReportSaleIntendantBranchReducer === void 0 ? void 0 : (_getReportSaleIntendantBranchReducer_data = getReportSaleIntendantBranchReducer.data) === null || _getReportSaleIntendantBranchReducer_data === void 0 ? void 0 : (_getReportSaleIntendantBranchReducer_data_data = _getReportSaleIntendantBranchReducer_data.data) === null || _getReportSaleIntendantBranchReducer_data_data === void 0 ? void 0 : _getReportSaleIntendantBranchReducer_data_data.datalist) || []);
            setSummary((getReportSaleIntendantBranchReducer === null || getReportSaleIntendantBranchReducer === void 0 ? void 0 : (_getReportSaleIntendantBranchReducer_data1 = getReportSaleIntendantBranchReducer.data) === null || _getReportSaleIntendantBranchReducer_data1 === void 0 ? void 0 : (_getReportSaleIntendantBranchReducer_data_data1 = _getReportSaleIntendantBranchReducer_data1.data) === null || _getReportSaleIntendantBranchReducer_data_data1 === void 0 ? void 0 : _getReportSaleIntendantBranchReducer_data_data1.summary) || {});
        }
        if (getShopReducer.data) {
            var arr = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var seen = new Set();
            var uniqueData = getShopReducer.data.data.filter(function(ele) {
                var _ele_shShop;
                var name = (_ele_shShop = ele.shShop) === null || _ele_shShop === void 0 ? void 0 : _ele_shShop.sh_shop_name;
                if (name && !seen.has(name)) {
                    seen.add(name);
                    return true;
                }
                return false;
            }).map(function(ele) {
                var _ele_shShop;
                return {
                    value: ele.sh_branch_shid,
                    label: (_ele_shShop = ele.shShop) === null || _ele_shShop === void 0 ? void 0 : _ele_shShop.sh_shop_name
                };
            });
            setOptionShop(_to_consumable_array(arr).concat(_to_consumable_array(uniqueData)));
        }
        if (allSetUserReducer.data) {
            var arr1 = isSaleRole ? [
                {
                    value: Number(adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId),
                    label: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName) || "เซลล์ของฉัน"
                }
            ] : [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            if (!isSaleRole) {
                allSetUserReducer.data.data.filter(function(v) {
                    return v.sys_user_role_id == 3;
                }).forEach(function(ele) {
                    return arr1.push({
                        value: ele === null || ele === void 0 ? void 0 : ele.sys_user_id,
                        label: ele === null || ele === void 0 ? void 0 : ele.sys_user_fullname
                    });
                });
            }
            setOptionSale(arr1);
        }
    }, [
        getReportSaleIntendantBranchReducer,
        getShopReducer,
        allSetUserReducer
    ]);
    var filteredRowData = useMemo(function() {
        var searchText = filterText.trim().toLowerCase();
        if (!searchText) {
            return rowData;
        }
        var getShopTypeText = function(type) {
            return type == 1 && "RT" || type == 2 && "WT" || type == 3 && "MT" || "";
        };
        return rowData.filter(function(row) {
            return [
                row === null || row === void 0 ? void 0 : row.sys_user_fullname,
                row === null || row === void 0 ? void 0 : row.sh_shop_code,
                row === null || row === void 0 ? void 0 : row.sh_shop_name,
                row === null || row === void 0 ? void 0 : row.sh_branch_code,
                row === null || row === void 0 ? void 0 : row.sh_branch_name,
                getShopTypeText(row === null || row === void 0 ? void 0 : row.sh_shop_typeshop),
                getBranchGradeText(row === null || row === void 0 ? void 0 : row.sh_branch_grade),
                getPaymentText(row === null || row === void 0 ? void 0 : row.sh_branch_paystatus, row === null || row === void 0 ? void 0 : row.sh_branch_creditday),
                getShippingPayTypeText(row === null || row === void 0 ? void 0 : row.sh_branch_shipping_paytype)
            ].some(function(value) {
                return String(value !== null && value !== void 0 ? value : "").toLowerCase().includes(searchText);
            });
        });
    }, [
        rowData,
        filterText
    ]);
    var sortedRowData = useMemo(function() {
        return _to_consumable_array(filteredRowData).sort(function(a, b) {
            var _SHOP_TYPE_ORDER_Number, _SHOP_TYPE_ORDER_Number1;
            var typeCompare = ((_SHOP_TYPE_ORDER_Number = SHOP_TYPE_ORDER[Number(a === null || a === void 0 ? void 0 : a.sh_shop_typeshop)]) !== null && _SHOP_TYPE_ORDER_Number !== void 0 ? _SHOP_TYPE_ORDER_Number : 99) - ((_SHOP_TYPE_ORDER_Number1 = SHOP_TYPE_ORDER[Number(b === null || b === void 0 ? void 0 : b.sh_shop_typeshop)]) !== null && _SHOP_TYPE_ORDER_Number1 !== void 0 ? _SHOP_TYPE_ORDER_Number1 : 99);
            if (typeCompare !== 0) {
                return typeCompare;
            }
            var saleCompare = ((a === null || a === void 0 ? void 0 : a.sys_user_fullname) || "").localeCompare((b === null || b === void 0 ? void 0 : b.sys_user_fullname) || "", "th");
            if (saleCompare !== 0) {
                return saleCompare;
            }
            var shopCompare = ((a === null || a === void 0 ? void 0 : a.sh_shop_name) || "").localeCompare((b === null || b === void 0 ? void 0 : b.sh_shop_name) || "", "th");
            if (shopCompare !== 0) {
                return shopCompare;
            }
            return ((a === null || a === void 0 ? void 0 : a.sh_branch_name) || "").localeCompare((b === null || b === void 0 ? void 0 : b.sh_branch_name) || "", "th");
        });
    }, [
        filteredRowData
    ]);
    var handlePrintOrderNote = function() {
        var _ref = _async_to_generator(function(row) {
            var _response_data, accessToken, response, _response_data_data, _ref, orderNoteData, blob, branchCode, error, _error_response, _error_response_data, _error_response1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        accessToken = localStorage.getItem("accessToken");
                        return [
                            4,
                            http.post(endPoint.REPORT_SALEINTENTBRANCH_ORDER_NOTE, {
                                branchid: Number(row === null || row === void 0 ? void 0 : row.sh_branch_id)
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(accessToken)
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        orderNoteData = (_ref = (_response_data_data = response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) !== null && _response_data_data !== void 0 ? _response_data_data : response === null || response === void 0 ? void 0 : response.data) !== null && _ref !== void 0 ? _ref : {};
                        if (!Array.isArray(orderNoteData === null || orderNoteData === void 0 ? void 0 : orderNoteData.products) || !orderNoteData.products.length) {
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "ไม่พบข้อมูล",
                                navigateDirection: undefined,
                                title: "สาขานี้ยังไม่มีประวัติสินค้าที่เคยสั่ง"
                            }));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(BranchOrderNoteDocument, {
                                data: orderNoteData
                            })).toBlob()
                        ];
                    case 3:
                        blob = _state.sent();
                        branchCode = (row === null || row === void 0 ? void 0 : row.sh_branch_code) || (row === null || row === void 0 ? void 0 : row.sh_branch_id) || "branch";
                        saveAs(blob, "ใบจดออเดอร์-".concat(branchCode, ".pdf"));
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                            visible: true,
                            subTitle: "รหัส ".concat((error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) || 500),
                            navigateDirection: undefined,
                            title: (error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || "ไม่สามารถสร้างใบจดออเดอร์ได้"
                        }));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePrintOrderNote(row) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleExportExcel = function() {
        var worksheet = buildSaleIntendantBranchWorksheet(sortedRowData);
        var workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "เซลล์ดูแลร้านค้า");
        writeFileXLSX(workbook, "รายงานเซลล์ดูแลร้านค้า_".concat(new Date().toISOString().slice(0, 10), ".xlsx"));
    };
    var columns = [
        {
            name: "จัดการ",
            center: "true",
            width: "80px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    variant: "link",
                    className: "m-0 p-0",
                    title: "PDF ใบจดออเดอร์",
                    onClick: function() {
                        return handlePrintOrderNote(row);
                    },
                    children: /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                        style: {
                            borderRadius: 40,
                            fontSize: 32,
                            background: "#FDE8E8",
                            color: "#B00412",
                            padding: 5
                        }
                    })
                });
            }
        },
        {
            name: "เซลล์",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sys_user_fullname;
            },
            center: "true"
        },
        {
            name: "รหัสร้านค้า",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sh_shop_code;
            },
            center: "true"
        },
        {
            name: "ร้านค้า",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sh_shop_name;
            },
            center: "true"
        },
        {
            name: "รหัสสาขา",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sh_branch_code;
            },
            center: "true"
        },
        {
            name: "สาขา",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sh_branch_name;
            },
            center: "true"
        },
        {
            name: "ประเภทร้าน",
            selector: function(row) {
                return getShopTypeText(row === null || row === void 0 ? void 0 : row.sh_shop_typeshop);
            },
            center: "true"
        },
        {
            name: "การชำระเงิน",
            selector: function(row) {
                return getPaymentText(row === null || row === void 0 ? void 0 : row.sh_branch_paystatus, row === null || row === void 0 ? void 0 : row.sh_branch_creditday);
            },
            center: "true"
        },
        {
            name: "ชำระค่าขนส่ง",
            selector: function(row) {
                return getShippingPayTypeText(row === null || row === void 0 ? void 0 : row.sh_branch_shipping_paytype);
            },
            center: "true",
            cell: function(row) {
                var isDestination = Number(row === null || row === void 0 ? void 0 : row.sh_branch_shipping_paytype) === 2;
                return /*#__PURE__*/ _jsx("span", {
                    className: "badge rounded-pill ".concat(isDestination ? "bg-warning text-dark" : "bg-success text-white"),
                    children: getShippingPayTypeText(row === null || row === void 0 ? void 0 : row.sh_branch_shipping_paytype)
                });
            }
        },
        {
            name: "ระดับร้านค้า",
            selector: function(row) {
                return getBranchGradeText(row === null || row === void 0 ? void 0 : row.sh_branch_grade);
            },
            center: "true"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานเซลล์ดูแลร้านค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานเซลล์ดูแลร้านค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#b4e2f3] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(StorefrontIcon, {})
                                            }),
                                            "จำนวนร้านค้า"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.totalshop) || 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d5eafa] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(AddBusinessIcon, {})
                                            }),
                                            "จำนวนสาขา"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.totalbranch) || 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d4f3cd] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(StoreIcon, {})
                                            }),
                                            "จำนวนร้านค้า RT"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.totalshopRT) || 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#ffe1d3] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(StoreIcon, {})
                                            }),
                                            "จำนวนร้านค้า WT"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.totalshopWT) || 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#ff0000] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(StoreIcon, {})
                                            }),
                                            "จำนวนร้านค้า MT"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.totalshopMT) || 0
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4 pb-0",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหาเซลล์ที่ดูแล"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                className: "w-100 select-st-3",
                                                placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                options: optionSale,
                                                value: optionSale.find(function(opt) {
                                                    return opt.value === saleId;
                                                }) || "",
                                                onChange: function(e) {
                                                    setSaleId(e ? e.value : "");
                                                },
                                                isClearable: !isSaleRole,
                                                isDisabled: isSaleRole
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาร้านค้า",
                                                options: optionShop,
                                                value: optionShop.find(function(opt) {
                                                    return opt.value === shopId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setShopId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาประเภทร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาประเภทร้านค้า",
                                                options: optionShopType,
                                                value: optionShopType.find(function(opt) {
                                                    return opt.value === shopTypeId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setShopTypeId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหาทุกคอลัมน์"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                className: "form-control",
                                                style: {
                                                    height: 38,
                                                    minHeight: 38,
                                                    padding: "0 12px"
                                                },
                                                placeholder: "ค้นหาทุกคอลัมน์",
                                                value: filterText,
                                                onChange: function(e) {
                                                    return setFilterText(e.target.value);
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ระดับร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "ระดับร้านค้า",
                                                options: optionBranchGrade,
                                                value: optionBranchGrade.find(function(opt) {
                                                    return opt.value === branchGrade;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setBranchGrade(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "การชำระเงิน"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "การชำระเงิน",
                                                options: optionPayStatus,
                                                value: optionPayStatus.find(function(opt) {
                                                    return opt.value === payStatus;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setPayStatus(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-1 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ชำระค่าขนส่ง"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3",
                                                placeholder: "ชำระค่าขนส่ง",
                                                options: optionShippingPayType,
                                                value: optionShippingPayType.find(function(opt) {
                                                    return opt.value === shippingPayType;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setShippingPayType(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex justify-content-end align-items-end h-100",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "success",
                                            onClick: handleExportExcel,
                                            disabled: isloading || sortedRowData.length === 0,
                                            children: "Export Excel"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: sortedRowData,
                        columns: columns,
                        isSelectRows: false,
                        PerPage: 10,
                        conditionalRowStyles: SHOP_TYPE_ROW_STYLES
                    })
                ]
            })
        ]
    });
}
